import { FC, useState, createContext } from 'react';
import { eepLanguageService } from "src/services";
import { EEPLanguageModel } from "src/models/businessManager/businessManager.model";
import { CURRENT_USER } from 'src/constants';

type EEPLanguageContext = {
    setEEPLanguage: () => any;
    setEEPLanguageDataContext: (dataValue) => void;
    EEPLanguageDataKO: boolean;
    setEEPLanguageDataKOContext: (dataValue) => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EEPLanguageContext = createContext<EEPLanguageContext>(
    {} as EEPLanguageContext
);

export const EEPLanguageProvider: FC = ({ children }) => {
    const [EEPLanguageData, setEEPLanguageData] = useState<EEPLanguageModel[]>(null);
    // check data
    const [EEPLanguageDataKO, setEEPLanguageDataKO] = useState<boolean>(false);
    const setEEPLanguageDataKOContext = (dataValue) => {
        setEEPLanguageDataKO(dataValue);
    };
    const setEEPLanguageDataContext = (dataValue) => {
        // check data temp
        if (dataValue == null || dataValue.length == 0) {
            setEEPLanguageDataKO(false);
        }
        setEEPLanguageData(dataValue);
        // check data
        for (let i = 0; i < dataValue.length; i++) {
            if (dataValue[i].name == null || dataValue[i].name == "" || dataValue[i].idLanguageLevel == null || dataValue[i].idLanguageLevel == 0) {
                setEEPLanguageDataKO(true);
                break;
            } else {
                setEEPLanguageDataKO(false);
            }
        }
    };
    const setEEPLanguage = async () => {
        let errorMessage = "";
        if (EEPLanguageData != null && EEPLanguageData.length > 0) {
            await eepLanguageService.updateByIdEa(EEPLanguageData, EEPLanguageData[0].idEa).then(response => {
                if (!response.data.success) {
                    errorMessage = '- ' + response.data.message;
                }
            }).catch(err => {
                errorMessage = '- ' + err.response.data.message;
            });
        }
        return errorMessage;
    }
    return (
        <>
            <EEPLanguageContext.Provider value={{
                setEEPLanguage,
                setEEPLanguageDataContext,
                EEPLanguageDataKO,
                setEEPLanguageDataKOContext
            }}>
                {children}
            </EEPLanguageContext.Provider>
        </>
    );
};
